import script from "./ProfilePasswordReset.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePasswordReset.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilePasswordReset.vue?vue&type=style&index=0&id=10fdf3bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10fdf3bb"]])

export default __exports__